var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "flex sm12 m12 cuadraturaOS" },
    [
      _c(
        "FormFieldsContainer",
        [
          _c(
            "v-flex",
            {
              attrs: {
                sm12: "",
                md12: "",
                layout: "",
                wrap: "",
                "mt-4": "",
                "mb-2": ""
              }
            },
            [
              _c(
                "v-flex",
                { attrs: { xs12: "", sm9: "", md9: "", layout: "", wrap: "" } },
                [
                  _c(
                    "v-flex",
                    { attrs: { sm12: "", md12: "", layout: "" } },
                    [
                      _c(
                        "v-flex",
                        { attrs: { xs12: "", sm4: "", md4: "" } },
                        [
                          _c("v-autocomplete", {
                            attrs: {
                              label: "Tipo de fecha",
                              items: _vm.tipo_fecha,
                              "item-text": "texto",
                              "item-value": "valor",
                              "no-data-text": "Sin resultados",
                              "prepend-icon": "home_repair_service"
                            },
                            model: {
                              value: _vm.estadofecha,
                              callback: function($$v) {
                                _vm.estadofecha = $$v
                              },
                              expression: "estadofecha"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "v-flex",
                        { attrs: { xs12: "", sm4: "", md4: "" } },
                        [
                          _c("DatePicker", {
                            attrs: { label: "Fecha Inicio", max: _vm.now },
                            model: {
                              value: _vm.fechaInicio,
                              callback: function($$v) {
                                _vm.fechaInicio = $$v
                              },
                              expression: "fechaInicio"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "v-flex",
                        { attrs: { xs12: "", sm4: "", md4: "" } },
                        [
                          _c("DatePicker", {
                            attrs: { label: "Fecha Fin", max: _vm.now },
                            model: {
                              value: _vm.fechaFin,
                              callback: function($$v) {
                                _vm.fechaFin = $$v
                              },
                              expression: "fechaFin"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "v-flex",
                        { attrs: { xs12: "", sm4: "", md4: "" } },
                        [
                          _c("v-text-field", {
                            attrs: {
                              label: "Serie",
                              "prepend-icon": "home_repair_service"
                            },
                            model: {
                              value: _vm.serie,
                              callback: function($$v) {
                                _vm.serie = $$v
                              },
                              expression: "serie"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "v-flex",
                        { attrs: { xs12: "", sm4: "", md4: "" } },
                        [
                          _c("v-autocomplete", {
                            attrs: {
                              label: "Estado Cuadratura",
                              items: _vm.estados,
                              "item-text": "texto",
                              "item-value": "valor",
                              "no-data-text": "Sin resultados",
                              "prepend-icon": "home_repair_service"
                            },
                            model: {
                              value: _vm.estadocuadratura,
                              callback: function($$v) {
                                _vm.estadocuadratura = $$v
                              },
                              expression: "estadocuadratura"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "v-flex",
                {
                  attrs: { xs12: "", sm3: "", md3: "", layout: "", "mt-2": "" }
                },
                [
                  _c(
                    "v-btn",
                    {
                      attrs: { flat: "", icon: "", small: "" },
                      on: { click: _vm.onFilterTextBoxChanged }
                    },
                    [_c("v-icon", [_vm._v("search")])],
                    1
                  ),
                  _c(
                    "v-btn",
                    { attrs: { flat: "", icon: "", small: "" } },
                    [
                      _c("v-icon", { on: { click: _vm.clearFilters } }, [
                        _vm._v("clear")
                      ])
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c("v-divider"),
      _c(
        "v-flex",
        {
          attrs: {
            sm12: "",
            md12: "",
            layout: "",
            "justify-end": "",
            "align-center": "",
            "mt-3": "",
            "mb-4": ""
          }
        },
        [
          _c(
            "v-btn",
            {
              attrs: { flat: "", small: "", color: "primary" },
              on: { click: _vm.getCSV }
            },
            [
              _c("v-icon", { staticClass: "importExportBtnIcon" }, [
                _vm._v("cloud_download")
              ]),
              _vm._v("\n        \n      "),
              _c("span", { staticClass: "importExportBtnTexto" }, [
                _vm._v("Exportar"),
                _c("br"),
                _vm._v("CSV")
              ])
            ],
            1
          )
        ],
        1
      ),
      _c("MantenedorGridTodos", {
        attrs: {
          "grid-options": _vm.gridOptions,
          funcionalidadId: _vm.funcionalidad
        },
        on: {
          gridOptionsEnriched: function($event) {
            _vm.enrichedGridOptions = $event
          }
        }
      }),
      _vm.showModalViewDetail
        ? _c("VerDetalleCuadratura", {
            attrs: {
              detalleId: _vm.idSeleccionado,
              detalleglosa: _vm.glosa,
              Categoriaglosa: _vm.categoriatipo,
              detallePatente: _vm.patenteSeleccionada,
              Cuadratura: _vm.estadoCuadraturaDisplay
            },
            on: {
              "update:value": _vm.handleCerrar,
              estadoActualizado: _vm.handleEstadoActualizado,
              glosaUpdated: _vm.handleGlosaUpdated
            }
          })
        : _vm._e(),
      _vm.showPopUpReport
        ? _c("PopUpGeneratedReports", {
            attrs: { text: _vm.msgReport },
            on: { cerrar: _vm.handleCloseReport }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }